import styled from 'styled-components';
import { Container } from 'reactstrap';

export const StyledContainer = styled(Container)`
  @media print {
    @page {
      size: A4;
    }
    * {
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
      print-color-adjust: exact;
    }
    .tab-pane {
      display: block;
    }
    .sticky-outer-wrapper {
      display: none;
    }
    .card-body {
      padding: 0;
    }
  }
`;
